/* eslint-disable react/require-default-props */
import React, { useMemo } from "react";
import DxpPageShell from "./Common/StandaloneFormViews/DxpPageShell";
import {
  createDxpClickHandler,
  getDXPRegistrationLink,
} from "../Helpers/utils";
import { PROGRAM_SPECIFIC_NAMES } from "../Helpers/constants";
import { resolveTemplateExternalHref } from "./Common/StandaloneFormViews/resolveExternalHref";
import { prepareDxpImsRedirectStorage } from "../Helpers/dxpAdobeImsAuth";
import useBackButtonOverride from "../Hooks/useBackButtonOverride";
import {
  DxpBodyText,
  DxpHeading,
  DxpMessageCard,
  DxpNarrowColumn,
  DxpPrimaryButton,
  DxpInlineLink,
} from "./dxpStandaloneUi";
import DxpRegistrationTopHeader from "./DxpRegistrationTopHeader";

interface IInviteContact {
  type?: string;
}

const PROGRAM = "DXP";

export default function InviteContact({ type }: IInviteContact) {
  useBackButtonOverride(getDXPRegistrationLink());

  const onAction = useMemo(() => createDxpClickHandler(), []);
  const email = localStorage.getItem("email") || "";
  const { title } = PROGRAM_SPECIFIC_NAMES.DXP.partnerProgram;

  const aemHref = resolveTemplateExternalHref({
    endpointPath: "environment.aemHomePageUrl",
    redirect: { type: "external", path: "/digitalexperience/" },
  });

  if (type === "invalid") {
    return (
      <>
        <DxpRegistrationTopHeader program={PROGRAM} />

        <DxpPageShell requireCommonHeaders>
          <div className="dxp-static-message-outer">
            <DxpNarrowColumn>
              <DxpMessageCard className="dxp-message-card--min-h-350">
                <DxpHeading>
                  Complete your registration to join <span>{title}</span>
                </DxpHeading>
                <DxpBodyText className="dxp-body-text--bold dxp-body-text--fs-18">
                  Invalid email address
                </DxpBodyText>
                <div className="dxp-flex-end dxp-flex-end--mt-16">
                  <DxpPrimaryButton
                    label="Enter Adobe ID"
                    onPress={() => {
                      prepareDxpImsRedirectStorage();
                      window.adobeIMS?.signIn?.();
                    }}
                    variant="accent"
                    className="dxp-wizard-cta-inverse"
                  />
                </div>
                <div className="dxp-bordered-block-top-muted">
                  {aemHref ? (
                    <DxpInlineLink
                      href={aemHref}
                      label="Go to the Digital Experience Partner Program home page"
                      newTab
                    />
                  ) : null}
                </div>
              </DxpMessageCard>
            </DxpNarrowColumn>
          </div>
        </DxpPageShell>
      </>
    );
  }

  return (
    <>
      <DxpRegistrationTopHeader program={PROGRAM} />

      <DxpPageShell requireCommonHeaders>
        <div className="dxp-static-message-outer">
          <DxpNarrowColumn>
            <DxpMessageCard className="dxp-message-card--min-h-350">
              <DxpHeading>
                Thanks for your interest in the Adobe Digital Experience Partner
                Program.
              </DxpHeading>
              <DxpBodyText>
                You were invited to join the Adobe Digital Experience Partner
                Program with this email address:{" "}
                <span className="dxp-text-strong-dark">{email}</span>.
              </DxpBodyText>
              <DxpBodyText>
                We&apos;ve already added some information to help you started.
                Click on the button below to complete your registration.
              </DxpBodyText>
              <div className="dxp-flex-end">
                <DxpPrimaryButton
                  label="Complete registration now"
                  onPress={() =>
                    onAction({ actionType: "continueRegistration" })
                  }
                  variant="accent"
                  className="dxp-wizard-cta-inverse"
                />
              </div>
              {aemHref ? (
                <div className="dxp-mt-20-only">
                  <DxpInlineLink
                    href={aemHref}
                    label="Go to the Digital Experience Partner Program home page"
                    newTab
                  />
                </div>
              ) : null}
            </DxpMessageCard>
          </DxpNarrowColumn>
        </div>
      </DxpPageShell>
    </>
  );
}
